import AuthService from '../lib/AuthService';

import { LOGIN_REQUEST, LOGIN_FAILURE, LOGIN_SUCCESS, LOGOUT_SUCCESS } from '../actions/actionTypes';

export default function authReducer(
  state = {
    isAuthenticated: !AuthService.isTokenExpired(),
    isFetching: false,
    profile: AuthService.getProfile(),
    error: null,
  },
  action,
) {
  // noinspection Eslint
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, isFetching: true, error: null };
    case LOGIN_SUCCESS:
      return { ...state, isFetching: false, isAuthenticated: true, profile: action.profile };
    case LOGIN_FAILURE:
      return { ...state, isFetching: false, isAuthenticated: false, profile: {}, error: action.error };
    case LOGOUT_SUCCESS:
      return { ...state, isAuthenticated: false, profile: {} };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js